import {
  call, put, select, takeLatest,
} from 'redux-saga/effects';
import {
  apiCreateNotificationServiceThreshold,
} from '../../create-threshold/api/CreateThresholdAPI';
import {
  apiDeleteThreshold,
  apiFetchElementTypes,
  apiUpdateThreshold,
} from '../../api/NotificationServiceThresholdAPI';
import {
  createThresholdSuccessActionCreator,
  createThresholdFailureActionCreator,
  getElementTypesSuccessActionCreator,
  getElementTypesFailureActionCreator,
  deleteThresholdSuccessActionCreator,
  deleteThresholdFailureActionCreator,
  editThresholdSuccessActionCreator,
  editThresholdFailureActionCreator,
} from '../actions/NotificationServiceActions';
import {
  CREATE_THRESHOLD_REQUEST,
  GET_ELEMENT_TYPES_REQUEST,
  DELETE_THRESHOLD_REQUEST,
  EDIT_THRESHOLD_REQUEST,
} from '../actions/types/NotificationServiceActionTypes';
import { languageSelector } from '../../../../../common/redux/selectors/languageSelector';
import { showNotification } from '../../../../../common/notifications/redux/actions/NotificationActions';
import { formatMessage } from '../../../../../../locales/locales';

function* postAddNewThresholdWorker(action) {
  const lang = yield select(languageSelector);
  try {
    const res = yield call(apiCreateNotificationServiceThreshold, action.payload);
    yield put(createThresholdSuccessActionCreator(res.data));
    yield put(showNotification({
      type: 'SUCCESS',
      message: formatMessage(lang, 'notification.threshold.add.success'),
    }));
  } catch (error) {
    yield put(createThresholdFailureActionCreator(error));
    yield put(showNotification({
      type: 'ERROR',
      message: error.response.data.message || formatMessage(lang, 'notification.threshold.add.failure'),
    }));
  }
}

function* getElementTypesWorker() {
  try {
    const res = yield call(apiFetchElementTypes);
    yield put(getElementTypesSuccessActionCreator(res.data));
  } catch (error) {
    yield put(getElementTypesFailureActionCreator(error));
  }
}

function* doDeleteThresholdWorker(action) {
  const lang = yield select(languageSelector);
  try {
    const res = yield call(apiDeleteThreshold, action.payload);
    yield put(deleteThresholdSuccessActionCreator(res.data));
    yield put(showNotification({
      type: 'SUCCESS',
      message: formatMessage(lang, 'notification.threshold.delete.success'),
    }));
  } catch (error) {
    yield put(deleteThresholdFailureActionCreator(error));
    yield put(showNotification({
      type: 'ERROR',
      message: error.response.data.message || 'Request failed.',
    }));
  }
}

function* doEditThresholdWorker(action) {
  const lang = yield select(languageSelector);
  try {
    const res = yield call(apiUpdateThreshold, action.payload);
    yield put(editThresholdSuccessActionCreator(res.data));
    yield put(showNotification({
      type: 'SUCCESS',
      message: formatMessage(lang, 'notification.threshold.edit.success'),
    }));
  } catch (error) {
    yield put(editThresholdFailureActionCreator(error, action.payload));
    yield put(showNotification({
      type: 'ERROR',
      message: error.response.data.message || 'Request failed.',
    }));
  }
}

function* NotificationServiceWatcher() {
  yield takeLatest(CREATE_THRESHOLD_REQUEST, postAddNewThresholdWorker);
  yield takeLatest(GET_ELEMENT_TYPES_REQUEST, getElementTypesWorker);
  yield takeLatest(DELETE_THRESHOLD_REQUEST, doDeleteThresholdWorker);
  yield takeLatest(EDIT_THRESHOLD_REQUEST, doEditThresholdWorker);
}
export default NotificationServiceWatcher;
export {
  postAddNewThresholdWorker,
  getElementTypesWorker,
  doDeleteThresholdWorker,
  doEditThresholdWorker,
};
